import { useState } from "react";
import BgMusicContainer from "./BgMusicContainer/BgMusicContainer";
import BgMusicTabsNav from "./BgMusicTabsNav/BgMusicTabsNav";
import { IMusicResponse } from "@/services/mixCutDetail/mixCutDetail";
import "./BgMusicTabs.less";
import CustomMusicGroup from "./CustomMusicGroup/CustomMusicGroup";
import { IMaterialDetail } from "@/services/createSpace/graphQ/getSimpleMedia";
import useCoverAndBg from "@/useStore/quickCut/useCoverAndBg";
import { LoadingType } from "@/requestHooks/mixCutDetail/useRequest";
import QuickStore from '@/stores/quickCutStore'
import { observer } from "mobx-react";
import CustomNewMusic from './CustomNewMusic'
export interface IBuMusicTabs {
  list: { name: string; collection_id: number }[];
  musicList: IMusicResponse[];
  activeId: number;
  selfMusicList: IMaterialDetail[];
  favoriteMusicList: IMusicResponse[];
  publicLoading: boolean;
  favoriteLoading: boolean;
  handleListActiveIdChange: (id: number) => void;
  handleMusicCollectBtcClick: (id: number) => void;
  handleSelfUploadBlockBtnClick: () => void;
  handleDeleteCustomMusicItem: (id: number) => void;
  handleCancelCollectBtnClick: (id: number) => void;
  searchLoading: boolean;
  selectAll?: boolean;
  getList: (page, isAppend) => void;
  hasMore: boolean;
  keyWord: string;
  isUserAction?: React.MutableRefObject<boolean>;
  emitIsUserAction: (value: boolean) => void;
}

const BgMusicTabs: React.FC<IBuMusicTabs> = (props) => {
  const {
    list,
    musicList,
    activeId,
    selfMusicList,
    favoriteMusicList,
    publicLoading,
    favoriteLoading,
    searchLoading,
    handleListActiveIdChange,
    handleSelfUploadBlockBtnClick,
    handleMusicCollectBtcClick,
    handleCancelCollectBtnClick,
    handleDeleteCustomMusicItem,
    selectAll,
    getList,
    hasMore,
    keyWord,
    isUserAction,
    emitIsUserAction
  } = props;
  const [isSelfBgContainer, setIsSelfBgContainer] = useState(false);
  const { handleBgAudiosChange, bgAudio } = useCoverAndBg();
  const { background } = QuickStore.quickcutData.settings;
  const hanldeBgMusiceNavIndexChange = (id: number) => {
    if (id === -1) {
      setIsSelfBgContainer(true);
    } else {
      setIsSelfBgContainer(false);
    }
    handleListActiveIdChange(id);
  };

  const handleCheckStateChange = (e: boolean, id: number) => {
    if (e) {
      const item = (selfMusicList as any[]).find(
        (item) => Number(item.id) === Number(id),
      );
      background.musics = [
        ...bgAudio,
        { ...item, duration: item.duration * 1000 },
      ]
      handleBgAudiosChange([
        ...bgAudio,
        { ...item, duration: item.duration * 1000 },
      ]);
    } else {
      const index = bgAudio.findIndex((item) => Number(item.id) === Number(id));
      bgAudio.splice(index, 1);
      background.musics = [...bgAudio]
      handleBgAudiosChange([...bgAudio]);
    }
  };

  return (
    <div className="bg-music-tabs">
      <BgMusicTabsNav
        activeId={activeId}
        handleActiveId={(e) => {
          hanldeBgMusiceNavIndexChange(e);
        }}
        navList={list}
      />
      {isSelfBgContainer ? (
        // <CustomMusicGroup
        //   handleDeleteCustomMusicItem={handleDeleteCustomMusicItem}
        //   handleSelfUploadBlockBtnClick={handleSelfUploadBlockBtnClick}
        //   data={selfMusicList}
        //   collectionAudio={bgAudio}
        //   handleCheckStateChange={handleCheckStateChange}
        // />
        <CustomNewMusic isUserAction={isUserAction} emitIsUserAction={emitIsUserAction} keyWord={keyWord} selectAll={selectAll} />
      ) : (
        <BgMusicContainer
          hasMore={hasMore}
          getList={(page, isAppend) => {
            getList(page, isAppend)
          }}
          loading={publicLoading || favoriteLoading || searchLoading}
          data={musicList}
          handleMusicCollectBtcClick={handleMusicCollectBtcClick}
          handleCancelCollectBtnClick={handleCancelCollectBtnClick}
        />
      )}
    </div>
  );
};

export default observer(BgMusicTabs);
